import React from 'react';
import { uniqBy } from 'lodash';
import { Button, Checkbox, Dropdown, TextArea } from 'semantic-ui-react';
import { DatePicker } from 'antd';
import { toJS } from 'mobx';
import moment from 'moment';

import Modal from '../../shared/Modal';
import customFetch from '../../../utils/customFetch';
import ClientsStore from './ClientsStore';

const datePickerFormat = 'DD/MM/YYYY';

class ModalActionNotes extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      valueCheckbox: 'actionRequired',
      actionRequired: false,
      staffs: [],
      notes: [],
      actionNotes: '',
      checked: false,
      loading: true,
      actionRequiredDueDate: '',
      completedDate: '',
      staffId: '',
      Id: '',
    };
  }

  renderStaffsOptions = () => {
    return toJS(this.state.staffs).map(opt => ({
      text: opt.FullName,
      value: opt.Id,
    }));
  };

  handleFilterStaffs = (_, { value }) => {
    this.setState({
      ...this.state,
      staffId: value,
    });
  };

  handlePickerChange = name => momentValue => {
    this.setState(state => ({
      ...this.state,
      [name]: momentValue.format(),
    }));
  };

  async componentDidMount() {
    try {
      const staffsPromise = customFetch('/Company/GetStaffs', {
        method: 'POST',
      });

      const notesPromise = customFetch('/Company/GetActionNotes', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ sId: ClientsStore.modalParams.id }),
      });

      const [staffs, notes] = await Promise.all([staffsPromise, notesPromise]);

      notes.actionNotes.ActionRequired
        ? this.setState({
            valueCheckbox: 'actionRequired',
          })
        : this.setState({
            valueCheckbox: null,
          });

      this.setState({
        staffs: uniqBy(staffs.itemList, 'Id'),
        Id: notes.actionNotes.Id,
        staffId: notes.actionNotes.StaffId,
        actionRequiredDueDate: notes.actionNotes.ActionRequiredDueDate,
        actionNotes: notes.actionNotes.ActionNotes,
        completedDate: notes.actionNotes.CompletedDate,
        checked: notes.actionNotes.ActionCompleted,
      });
    } finally {
      this.setState({ loading: false });
    }
  }

  handleChange = (e, { value }) => {
    this.setState({ valueCheckbox: value });
    value === 'actionRequired'
      ? this.setState({
          actionRequired: true,
        })
      : this.setState({
          actionRequired: false,
        });
  };

  onCancel = () => {
    this.props.onCancel();
  };

  handleSubmitActionNotes = async () => {
    ClientsStore.setFieldsValue({ loading: true });
    try {
      await customFetch('/Company/PostActionNotes_Submit', {
        headers: { 'Content-Type': 'application/json' },
        method: 'POST',
        body: JSON.stringify({
          ActionCompleted: this.state.checked,
          ActionNotes: this.state.actionNotes,
          Id: this.state.Id,
          StaffId: this.state.staffId,
          ActionRequired: this.state.actionRequired,
          ActionRequiredDueDate: moment(
            this.state.actionRequiredDueDate,
          ).format(),
          CompletedDate: this.state.checked
            ? moment(this.state.completedDate).format()
            : null,
        }),
      }).then(respone => {
        if (respone.status === 'success') {
          this.props.onCancel();
        }
      });
      await ClientsStore.fetchClients({}, true);
    } finally {
      ClientsStore.setFieldsValue({ loading: false });
    }
  };

  render() {
    const { toggleModal, open } = ClientsStore;
    return (
      <React.Fragment>
        <Modal
          width={900}
          visible={open}
          onCancel={toggleModal(false)}
          title={`Acction Notes`}
          footer={
            <React.Fragment>
              <Button color="blue" onClick={this.handleSubmitActionNotes}>
                Save
              </Button>
              <Button className="negative" onClick={this.onCancel}>
                Cancel
              </Button>
            </React.Fragment>
          }
        >
          <div className="Wrap-content">
            <div className="Wrap-checkbox-top">
              <div className="Title">Action Type</div>
              <div className="Checkbox">
                <Checkbox
                  radio
                  label="Action Required"
                  name="actionRequired"
                  value="actionRequired"
                  checked={this.state.valueCheckbox === 'actionRequired'}
                  onChange={this.handleChange}
                />
                <Checkbox
                  radio
                  label="Urgent Report"
                  name="urgentReport"
                  value="urgentReport"
                  checked={this.state.valueCheckbox === 'urgentReport'}
                  onChange={this.handleChange}
                />
                <Checkbox
                  radio
                  label="None"
                  name="none"
                  value="none"
                  checked={this.state.valueCheckbox === 'none'}
                  onChange={this.handleChange}
                />
              </div>
            </div>

            <div className="Wrap-date">
              <div className="Title">Due Date</div>
              <DatePicker
                className="Date"
                allowClear={false}
                format={datePickerFormat}
                value={
                  this.state.actionRequiredDueDate
                    ? moment(this.state.actionRequiredDueDate)
                    : null
                }
                onChange={this.handlePickerChange('actionRequiredDueDate')}
              />
            </div>

            <div className="Wrap-dropdown">
              <div className="Title">PIC</div>
              <Dropdown
                placeholder="Select a staff"
                fluid
                search
                selection
                className="Dropdown"
                value={this.state.staffId}
                onChange={this.handleFilterStaffs}
                options={this.renderStaffsOptions()}
              />
            </div>

            <div className="Wrap-checkbox">
              <div className="Title">Action completed</div>
              <div className="Checkbox">
                <Checkbox
                  type="checkbox"
                  checked={this.state.checked}
                  onChange={() =>
                    this.setState({ checked: !this.state.checked })
                  }
                />
              </div>
            </div>

            {this.state.checked ? (
              <div className="Wrap-date">
                <div className="Title">Due Date</div>
                <DatePicker
                  className="Date"
                  allowClear={false}
                  format={datePickerFormat}
                  value={
                    this.state.completedDate
                      ? moment(this.state.completedDate)
                      : null
                  }
                  onChange={this.handlePickerChange('completedDate')}
                />
              </div>
            ) : null}

            <div className="Wrap-text">
              <div className="Title">Action notes</div>
              <TextArea
                value={this.state.actionNotes}
                className="Text"
                name="actionNotes"
                onChange={e => this.setState({ actionNotes: e.target.value })}
              />
            </div>

            <div className="Wrap-date">
              <div className="Title">Required Date for Report</div>
              <DatePicker className="Date" />
            </div>

            <div className="Wrap-date">
              <div className="Title">Due Date</div>
              <DatePicker className="Date" />
            </div>

            <div className="Wrap-dropdown">
              <div className="Title">PIC</div>
              <Dropdown
                placeholder="Select a staff"
                fluid
                search
                selection
                className="Dropdown"
                //value={notes.StaffId}
                options={this.renderStaffsOptions()}
              />
            </div>

            <div className="Wrap-checkbox">
              <div className="Title">Report completed</div>
              <div className="Checkbox">
                <Checkbox
                  radio
                  label="Report completed"
                  name="checkboxRadioGroup"
                  value="this"
                  //checked={this.state.valueCheckbox === 'this'}
                  //onChange={this.handleChange}
                />
              </div>
            </div>

            <div className="Wrap-text">
              <div className="Title">Urgent Report notes</div>
              <TextArea value={this.state.actionNotes} className="Text" />
            </div>
          </div>
        </Modal>
      </React.Fragment>
    );
  }
}

export default ModalActionNotes;
